/**
 * Đồng ý sinh trắc học và đăng ký khuôn mặt — docs/07 §7.5.
 *
 * Dữ liệu sinh trắc học thuộc nhóm NHẠY CẢM của Nghị định 13/2023/NĐ-CP. Hai
 * hệ quả nằm thẳng trong mã nguồn này:
 *
 *   · Phải có văn bản đồng ý ĐÃ KÝ trước khi gửi bất kỳ ảnh nào lên.
 *   · Ảnh đăng ký chỉ đi qua server để trích vector đặc trưng, KHÔNG được lưu.
 *
 * Rút lại đồng ý là quyền của nhân viên, và nó thu hồi luôn mọi mẫu đã có —
 * không có bước "để dành phòng khi đổi ý".
 */

import { request } from '../api/client'

export const dongYSinhTrac = (consent_version: string) =>
  request<{ id: number; da_co_san: boolean; phai_dang_ky_lai?: boolean }>(
    '/auth/consent-biometric', {
      method: 'POST',
      body: JSON.stringify({ consent_version, xac_nhan: true }),
    })

export const rutDongYSinhTrac = (reason: string) =>
  request<{ so_mau_da_thu_hoi: number }>('/auth/consent-biometric/withdraw', {
    method: 'POST', body: JSON.stringify({ reason }),
  })

/** Ảnh đăng ký chỉ đi qua server để trích vector, KHÔNG được lưu (docs/07). */
export function dangKyKhuonMat(anh: Blob) {
  const form = new FormData()
  form.append('photo', anh, 'dang-ky.webp')
  return request<{ template_id: number; so_mau: number; con_lai: number }>(
    '/auth/enroll-face', { method: 'POST', body: form })
}

export const thuHoiMauKhuonMat = () =>
  request<{ so_mau_da_thu_hoi: number }>('/auth/face-templates', { method: 'DELETE' })
